<template>
    <ModalComponent
        :name="name"
        title="Descargar resumen de ventas"
        v-on:close="() => close(false)"
    >
        <div class="card m-0" v-if="! loading">
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
                <div class="card-body">                    
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label for="provincias">Formato</label>
                                <multiselect
                                    v-model="formato"
                                    placeholder="Formato"
                                    label="value"
                                    track-by="value"
                                    :options="tipos"
                                    :multiple="false"
                                ></multiselect>
                            </div>                                            
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label for="fecha_envio">Fecha de inicio</label>
                                <datetime 
                                    v-model="fecha_inicio"
                                    input-class="form-control"
                                    type="date"
                                    input-id="fecha_inicio"
                                ></datetime>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label for="fecha_envio">Fecha de fin</label>
                                <datetime 
                                    v-model="fecha_fin"
                                    input-class="form-control"
                                    type="date"
                                    input-id="fecha_inicio"
                                ></datetime>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer text-right">
                    <Button type="submit">DESCARGAR</Button>
                    <Button type="button" name="button" class="ml-3" @click.prevent="close()">CERRAR</Button>
                </div>
            </ValidationObserver>
        </div>
        <template v-else>
            <div class="card m-0">
                <div class="card-body">                    
                    <div class="row">
                        <h2>Se esta generando el informe, recibirá una notificación para poder descargarlo cuando esté listo.</h2>
                    </div>
                </div>
            </div>
        </template>
    </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";

export default {
    props: ['name'],
    data() {
        return {
            loading: false,
            fecha_inicio: null,
            fecha_fin: null,
            tipos: [
                { value: 'xls'},
                { value: 'pdf'}
            ],
            formato: { value: 'xls'}
        }
    },
    methods: {
        close() {
            this.loading = false;
            this.$emit('close', this.name);
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                if(this.formato.value == 'pdf'){
                    var enlace = this.config.API_BASE + '/eventos/resumen-ventas/descargar?format=pdf&api_key=' + localStorage.getItem('token') + '&fecha_inicio=' + this.fecha_inicio + '&fecha_fin=' + this.fecha_fin;
                    window.open(enlace);
                    this.close(false);
                }else {
                    this.getInforme();
                }

            }
        },
        getInforme() {
            this.loading = true;
            const params = {
                filters : {
                    fecha_inicio: this.fecha_inicio,
                    fecha_fin: this.fecha_fin,
                    format: this.formato.value,
                },
            };
            this.$store.dispatch(this.config.getVuexAlias("back.events.resumen-ventas.descargar"), params).then(res => {
                this.loading = true
            });
        }
    },
    components: {
        ModalComponent
    }
}
</script>
